//https://chatgpt.com/c/69396cbb-2928-832b-83bc-468744cdbdc1

import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Badge,
  Card,
  Form,
} from "react-bootstrap";
import {
  TelephoneOutbound,
  ChatDots,
  ClockHistory,
  LightningChargeFill,
  ShieldCheck,
  PeopleFill,
  ArrowRight,
  CheckCircleFill,
} from "react-bootstrap-icons";

const Landing365AnsweringService_2025_12_10_chat: React.FC = () => {
  return (
    <div className="bg-light">
      {/* Top Navbar */}
      <Navbar bg="white" expand="lg" className="shadow-sm sticky-top">
        <Container>
          <Navbar.Brand href="#home" className="fw-bold d-flex align-items-center">
            <TelephoneOutbound className="me-2" />
            365AnsweringService<span className="text-primary">.com</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="main-nav" />
          <Navbar.Collapse id="main-nav" className="justify-content-end">
            <Nav className="me-3">
              <Nav.Link href="#how-it-works">How It Works</Nav.Link>
              <Nav.Link href="#features">Features</Nav.Link>
              <Nav.Link href="#industries">Who We Serve</Nav.Link>
              <Nav.Link href="#pricing">Pricing</Nav.Link>
              <Nav.Link href="#faq">FAQ</Nav.Link>
            </Nav>
            <Button variant="outline-primary" href="#demo">
              Book a Demo
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Hero Section */}
      <section id="home" className="py-5 py-lg-6">
        <Container>
          <Row className="align-items-center">
            <Col md={7}>
              <Badge bg="primary" pill className="mb-3">
                24/7 Live Answering • Never Miss a Call
              </Badge>
              <h1 className="display-5 fw-bold mb-3">
                Turn missed calls into <span className="text-primary">loyal customers</span>.
              </h1>
              <p className="lead text-muted mb-4">
                365AnsweringService.com provides friendly, professional live receptionists
                who answer your phones 24/7/365 — so you can focus on running your business,
                not babysitting your phone.
              </p>
              <div className="d-flex flex-column flex-md-row gap-3 mb-3">
                <Button size="lg" variant="primary" href="#demo" className="d-flex align-items-center">
                  Start Free Consultation
                  <ArrowRight className="ms-2" />
                </Button>
                <Button size="lg" variant="outline-secondary" href="#pricing">
                  View Pricing
                </Button>
              </div>
              <div className="d-flex flex-wrap align-items-center text-muted small">
                <CheckCircleFill className="text-success me-2" />
                <span className="me-3">Month-to-month. No long-term contracts.</span>
                <CheckCircleFill className="text-success me-2" />
                <span>US-based receptionists.</span>
              </div>
            </Col>
            <Col md={5} className="mt-4 mt-md-0">
              <Card className="shadow border-0">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <ChatDots className="me-2 text-primary" size={24} />
                    <h5 className="mb-0">Quick Quote Request</h5>
                  </div>
                  <p className="text-muted small mb-3">
                    Tell us a bit about your business and we’ll send a customized answering plan.
                  </p>
                  <Form>
                    <Form.Group className="mb-3" controlId="formName">
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control type="text" placeholder="Jane Doe" />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formEmail">
                      <Form.Label>Email</Form.Label>
                      <Form.Control type="email" placeholder="you@example.com" />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formPhone">
                      <Form.Label>Business Phone</Form.Label>
                      <Form.Control type="tel" placeholder="(555) 123-4567" />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formIndustry">
                      <Form.Label>Industry</Form.Label>
                      <Form.Select defaultValue="">
                        <option value="" disabled>
                          Select your industry
                        </option>
                        <option>Home Services</option>
                        <option>Healthcare / Dental</option>
                        <option>Legal / Professional</option>
                        <option>Real Estate / Property Management</option>
                        <option>Other</option>
                      </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formCallVolume">
                      <Form.Label>Estimated Calls per Month</Form.Label>
                      <Form.Select defaultValue="">
                        <option value="" disabled>
                          Choose volume
                        </option>
                        <option>0–50</option>
                        <option>51–150</option>
                        <option>151–400</option>
                        <option>400+</option>
                      </Form.Select>
                    </Form.Group>
                    <Button type="submit" variant="primary" className="w-100">
                      Get My Quote
                    </Button>
                    <p className="text-muted small mt-2 mb-0 text-center">
                      No obligation, no credit card required.
                    </p>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="py-5 bg-white">
        <Container>
          <Row className="mb-4">
            <Col md={8}>
              <h2 className="fw-bold">How 365AnsweringService.com works</h2>
              <p className="text-muted">
                Simple setup, powerful coverage. Get fully live answering in just a day.
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <Badge bg="light" text="dark" className="mb-2">
                    Step 1
                  </Badge>
                  <h5 className="fw-bold mb-2">Set up your script</h5>
                  <p className="text-muted small mb-3">
                    We help you create call scripts and FAQs so our receptionists sound just like your in-house team.
                  </p>
                  <ul className="small text-muted ps-3 mb-0">
                    <li>Greeting & brand voice</li>
                    <li>Call routing rules</li>
                    <li>Lead intake questions</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <Badge bg="light" text="dark" className="mb-2">
                    Step 2
                  </Badge>
                  <h5 className="fw-bold mb-2">We answer every call</h5>
                  <p className="text-muted small mb-3">
                    Our trained agents answer in your company name, qualify callers, and send you detailed messages.
                  </p>
                  <ul className="small text-muted ps-3 mb-0">
                    <li>24/7/365 coverage</li>
                    <li>Overflow & after-hours</li>
                    <li>Bilingual options available</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <Badge bg="light" text="dark" className="mb-2">
                    Step 3
                  </Badge>
                  <h5 className="fw-bold mb-2">You get qualified opportunities</h5>
                  <p className="text-muted small mb-3">
                    We deliver messages via email, SMS, or CRM — so your team only focuses on serious, ready-to-buy callers.
                  </p>
                  <ul className="small text-muted ps-3 mb-0">
                    <li>Instant message delivery</li>
                    <li>Appointment scheduling available</li>
                    <li>Call summaries & tags</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features */}
      <section id="features" className="py-5 bg-light">
        <Container>
          <Row className="mb-4">
            <Col md={8}>
              <h2 className="fw-bold">Why businesses choose 365AnsweringService.com</h2>
              <p className="text-muted">
                Designed for small and growing businesses that can’t afford to miss a single opportunity.
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col md={3} sm={6}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <ClockHistory className="mb-3" size={28} />
                  <h6 className="fw-bold">24/7/365 Coverage</h6>
                  <p className="text-muted small mb-0">
                    Nights, weekends, holidays—your phone is always answered by a real human.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={6}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <LightningChargeFill className="mb-3" size={28} />
                  <h6 className="fw-bold">Fast Response</h6>
                  <p className="text-muted small mb-0">
                    Average answer times in seconds, not minutes, to capture more leads.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={6}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <ShieldCheck className="mb-3" size={28} />
                  <h6 className="fw-bold">Secure & Compliant</h6>
                  <p className="text-muted small mb-0">
                    Confidential handling of sensitive calls with role-based scripts and approvals.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={6}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <PeopleFill className="mb-3" size={28} />
                  <h6 className="fw-bold">US-Based Receptionists</h6>
                  <p className="text-muted small mb-0">
                    Friendly, professional agents trained to represent your brand.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Industries */}
      <section id="industries" className="py-5 bg-white">
        <Container>
          <Row className="mb-4">
            <Col md={8}>
              <h2 className="fw-bold">Perfect for service-focused businesses</h2>
              <p className="text-muted">
                If phone calls drive your revenue, 365AnsweringService.com keeps that pipeline full.
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col md={3} sm={6}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <h6 className="fw-bold mb-2">Home Services</h6>
                  <p className="text-muted small mb-0">
                    Plumbers, HVAC, electricians, cleaning, and more—never miss an emergency call again.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={6}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <h6 className="fw-bold mb-2">Healthcare & Dental</h6>
                  <p className="text-muted small mb-0">
                    Manage appointment requests, urgent questions, and new patient intake securely.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={6}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <h6 className="fw-bold mb-2">Law Firms & Professional</h6>
                  <p className="text-muted small mb-0">
                    Capture high-value leads and handle after-hours calls professionally.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={6}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <h6 className="fw-bold mb-2">Real Estate & Property Mgmt</h6>
                  <p className="text-muted small mb-0">
                    Handle showing requests, maintenance calls, and tenant questions around the clock.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Pricing Teaser */}
      <section id="pricing" className="py-5 bg-light">
        <Container>
          <Row className="mb-4">
            <Col md={8}>
              <h2 className="fw-bold">Simple, transparent pricing</h2>
              <p className="text-muted">
                Plans based on usage, not long-term contracts. Start small and scale as you grow.
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm text-center">
                <Card.Body>
                  <h6 className="fw-bold mb-1">Starter</h6>
                  <p className="text-muted small mb-2">For solo & small businesses</p>
                  <h3 className="fw-bold mb-1">$99</h3>
                  <p className="text-muted mb-3">per month</p>
                  <ul className="text-muted small list-unstyled mb-4">
                    <li>✓ Up to 75 calls</li>
                    <li>✓ Business hours coverage</li>
                    <li>✓ Basic message handling</li>
                  </ul>
                  <Button variant="outline-primary" href="#demo">
                    Choose Starter
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 border-0 shadow-lg position-relative text-center">
                <Badge
                  bg="primary"
                  className="position-absolute top-0 start-50 translate-middle-x mt-2"
                >
                  Most Popular
                </Badge>
                <Card.Body className="pt-5">
                  <h6 className="fw-bold mb-1">Growth</h6>
                  <p className="text-muted small mb-2">For busy phone-based teams</p>
                  <h3 className="fw-bold mb-1">$199</h3>
                  <p className="text-muted mb-3">per month</p>
                  <ul className="text-muted small list-unstyled mb-4">
                    <li>✓ Up to 250 calls</li>
                    <li>✓ 24/7 coverage</li>
                    <li>✓ Lead qualification & tagging</li>
                    <li>✓ CRM & calendar integration*</li>
                  </ul>
                  <Button variant="primary" href="#demo">
                    Choose Growth
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm text-center">
                <Card.Body>
                  <h6 className="fw-bold mb-1">Custom & Enterprise</h6>
                  <p className="text-muted small mb-2">High volume or multi-location</p>
                  <h3 className="fw-bold mb-1">Let’s Talk</h3>
                  <p className="text-muted mb-3">custom pricing</p>
                  <ul className="text-muted small list-unstyled mb-4">
                    <li>✓ 400+ calls / month</li>
                    <li>✓ Dedicated account manager</li>
                    <li>✓ Custom reporting & SLAs</li>
                  </ul>
                  <Button variant="outline-secondary" href="#demo">
                    Talk to Sales
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <p className="text-muted small mb-0">
                *Integrations depend on your current phone system and CRM. Ask our team for details.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Demo / Contact Section */}
      <section id="demo" className="py-5 bg-white">
        <Container>
          <Row className="mb-4">
            <Col md={8}>
              <h2 className="fw-bold">Book your free 15-minute consultation</h2>
              <p className="text-muted">
                See how much revenue you’re leaving on the table with missed calls and slow response times.
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col md={7}>
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <Form>
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group controlId="demoName">
                          <Form.Label>Full Name</Form.Label>
                          <Form.Control type="text" placeholder="Jane Doe" />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="demoCompany">
                          <Form.Label>Company</Form.Label>
                          <Form.Control type="text" placeholder="Your Business Name" />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="demoEmail">
                          <Form.Label>Email</Form.Label>
                          <Form.Control type="email" placeholder="you@example.com" />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="demoPhone">
                          <Form.Label>Phone</Form.Label>
                          <Form.Control type="tel" placeholder="(555) 123-4567" />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group controlId="demoNotes">
                          <Form.Label>What do you need help with?</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Tell us about your call volume, pain points, and goals..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Check
                          type="checkbox"
                          id="demoConsent"
                          label="I agree to be contacted by phone or email about my inquiry."
                          className="small text-muted"
                        />
                      </Col>
                      <Col md={12}>
                        <Button type="submit" variant="primary" className="w-100">
                          Schedule My Consultation
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
            <Col md={5}>
              <Card className="border-0 h-100 shadow-sm">
                <Card.Body>
                  <h6 className="fw-bold mb-3">What to expect</h6>
                  <ul className="text-muted small ps-3 mb-4">
                    <li>Quick discovery of your current call handling process</li>
                    <li>Estimate of lost leads from missed calls</li>
                    <li>Suggested plan and pricing fit</li>
                    <li>Answers to integration & technical questions</li>
                  </ul>
                  <div className="border-top pt-3 small text-muted">
                    <p className="mb-1">
                      Prefer to call instead? Reach us at: <strong>(800) 365-ANSWER</strong>
                    </p>
                    <p className="mb-0">Available Monday–Friday, 8am–6pm (your local time).</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-5 bg-light">
        <Container>
          <Row className="mb-4">
            <Col md={8}>
              <h2 className="fw-bold">Frequently asked questions</h2>
            </Col>
          </Row>
          <Row className="g-3">
            <Col md={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body>
                  <h6 className="fw-bold">How quickly can we get started?</h6>
                  <p className="text-muted small mb-0">
                    In most cases we can have your account, scripts, and call routing live within 1–2 business days
                    after our onboarding call.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body>
                  <h6 className="fw-bold">Do you replace our receptionist?</h6>
                  <p className="text-muted small mb-0">
                    Not necessarily. Many clients use us for overflow and after-hours calls, while keeping an in-house
                    receptionist for in-office tasks.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body>
                  <h6 className="fw-bold">Can you schedule appointments for us?</h6>
                  <p className="text-muted small mb-0">
                    Yes. We can schedule into your existing calendar system (where supported) or follow your process for
                    booking and confirmations.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body>
                  <h6 className="fw-bold">Is there a long-term contract?</h6>
                  <p className="text-muted small mb-0">
                    No. Our standard plans are month-to-month. You can adjust your plan or cancel with notice according
                    to your agreement.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <footer className="py-4 bg-dark text-light">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="mb-3 mb-md-0">
              <div className="fw-bold">
                365AnsweringService<span className="text-primary">.com</span>
              </div>
              <div className="small text-muted">
                &copy; {new Date().getFullYear()} 365AnsweringService.com. All rights reserved.
              </div>
            </Col>
            <Col md={6} className="text-md-end small">
              <a href="#home" className="text-decoration-none text-light me-3">
                Back to top
              </a>
              <a href="#pricing" className="text-decoration-none text-light me-3">
                Pricing
              </a>
              <a href="#demo" className="text-decoration-none text-light">
                Book a Demo
              </a>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default Landing365AnsweringService_2025_12_10_chat;
